export const enDocumentManager = {
    translation: {
        "Gastos hipotecarios": "Mortgage expenses",
        "Prima única": "Single premium",
        "Brecha de género": "Gender Gap",
        "Contrato brecha de género": "Gender gap contract",
        "El impreso C-155 no se sube aquí: es un PDF oficial con formulario y va dentro del backend, no en S3.": "The C-155 form is not uploaded here: it is an official fillable PDF and lives inside the backend, not in S3.",
        "Reclamación gastos hipotecarios": "Mortgage expenses claim",
        "Declaración APUD": "APUD declaration",
        "Contrato gastos hipotecarios": "Mortgage expenses contract",
        "Prima única (Por defecto)": "Single premium (Default)",
        "(Prima única (CaixaBank)": "Single premium (CaixaBank)",
        "Prima única (Santander)": "Single premium (Santander)",
        "Contrato prima úncia": "Single premium contract",
        "Enviar": "Send",

    }   
}